<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Customer Rate"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedCustomerRates"
      :columns="columns"
      :total-rows="totalCustomerRates"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'CustomerRateTable',
  components: {
    BaseTable
  },
  data() {
    return {
      customerRates: [],
      totalCustomerRates: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'cust_name', align: 'left', label: 'Customer Name', field: 'cust_name', sortable: true },
        { name: 'crop_name', align: 'left', label: 'Crop', field: 'crop_name', sortable: true },
        { name: 'description', align: 'left', label: 'Description', field: 'description', sortable: true },
        { name: 'rate', align: 'right', label: 'Rate', field: 'rate', sortable: true },
        { name: 'at_moisture', align: 'right', label: 'At Moisture (%)', field: 'at_moisture', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedCustomerRates() {
      return this.customerRates.map(rate => ({
        ...rate,
        cust_name: rate.cust_id.name, // Assuming the API returns nested customer object with `name`
        crop_name: rate.crop_id.crop, // Assuming the API returns nested crop object with `crop`
        add_date: new Date(rate.add_date).toLocaleDateString(),
        edit_date: new Date(rate.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchCustomerRates();
  },
  methods: {
    fetchCustomerRates() {
      axios
        .get('/api/v1/customer_rate/customer_rates/')
        .then(response => {
          this.customerRates = response.data;
          this.totalCustomerRates = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching customer rates:', error);
        });
    },
    onAdd() {
      this.$router.push('/customer_rates/add');
    },
    getEditUrl(row) {
      return `/customer_rates/edit/${row.id}`;
    }
  },
  watch: {
    customerRates() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the CustomerRateTable here */
</style>
